module.exports = __webpack_public_path__ + "img/dammy06.5469d44e.jpg";